var irreducible = require('./irreducible');
var isString = require('./isString');

module.exports = irreducible('String', isString);



//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/String.js
// module id = 228
// module chunks = 0